module.exports = __webpack_public_path__ + "static/img/v1.c8ac0fbe.jpg";